module.exports = __webpack_public_path__ + "img/share-wz.b0448f5a.png";